import React, { useEffect } from 'react';
import { HubSpotForm } from './newsletter-modal.styled';

export interface formProps {
  formId: string;
  portalId: string;
}

declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (config: { portalId: string; formId: string; target: string }) => void;
      };
    };
  }
}

const NewsletterForm = ({ formId, portalId }: formProps): JSX.Element => {
  // hubspot form
  useEffect(() => {
    if (!formId) return;

    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId: formId || '',
          target: `#hubspot-form-${formId || ''}`,
        });
      }
    });
  }, [formId, portalId]);

  return <HubSpotForm id={`hubspot-form-${formId}`} />;
};

export default NewsletterForm;
